/**
 *
 * Feed Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { FeedSubRoutes } from 'modules/Feed/feedPagesConfig';
import { lazyWebFeedPage } from './lazyFeed';
import { lazyLoad } from 'utils/loadable';
import { Navigate } from 'react-router-dom';

const WebFeedPage = lazyLoad(() =>
  import(
    /*  webpackChunkName: 'WebFeedPage', webpackPrefetch: true */ './components/WebFeedPage'
  ),
);

export const feedMenuRoutes = [
  {
    component: WebFeedPage,
    title: 'Feed',
    path: FeedSubRoutes.FEED,
  },
  {
    component: WebFeedPage,
    title: 'Feed',
    path: FeedSubRoutes.FEED_LIST,
  },
  {
    component: WebFeedPage,
    title: 'Feed',
    path: FeedSubRoutes.FEED_POST,
  },
];

// routes declaration
export const webFeedRoutes = [
  {
    component: Navigate,
    path: '/feed',
    replace: true,
    to: '/feed' + FeedSubRoutes.FEED_ALL,
    needsAuth: true,
  },
  {
    component: lazyWebFeedPage,
    path: '/feed/*',
    title: 'Feed',
    needsAuth: true,
  },
];
